module.exports = __webpack_public_path__ + "static/img/system.5ba6d8fb.svg";